<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500">Channels</h4>
        </div>

        <div class="space-y-8">
          <BasePaginator v-if="meta" :disabled="pending" :meta="meta" @change="changePage" />

          <div v-if="pending" class="px-4 text-center">
            <Loader />
          </div>

          <BaseGrid v-else :columns="3">
            <template v-for="channel in channels">
              <ChannelCard
                :key="`${channel.id}_${channel.channableId}_${channel.channableType}`"
                :channel="channel"
              />
            </template>
          </BaseGrid>

          <BasePaginator v-if="meta" :disabled="pending" :meta="meta" @change="changePage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import ChannelCard from '@/components/AccountChannels/ChannelCard.vue';
import { accountChannelsClient } from '@/api/clients';

export default {
  components: {
    ChannelCard,
  },

  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    pending: false,
    channels: [],
    meta: null,
  }),
  watch: {
    $route: 'fetchData',
  },
  beforeRouteEnter: middleware('account-permission:read channels'),
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { accountId } = this;
      const { query: params } = this.$route;
      this.pending = true;
      try {
        const response = await accountChannelsClient.list(accountId, {
          params: {
            ...params,
            include: 'page,project.cover',
          },
        });

        this.channels = response.data.data;
        this.meta = response.data?.meta || null;
      } catch (error) {
        //
      }
      this.pending = false;
    },
    changePage(page) {
      const { currentRoute } = this.$router;

      this.$router.push({
        ...currentRoute,
        query: {
          page,
        },
      });
    },
  },
};
</script>
